<template>
  <el-container>
    <el-main>
        <el-dialog
          :title="$t('groupList.group')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="groupRoomVisible"
          style="margin-top:-70px"
          width="900px"
        > 
       <el-form :inline="true" class="demo-form-inline" style="margin-top:-30px;">
        <el-form-item :label="$t('roomList.apartment')">
        <el-select style="width:150px" v-model="selectForm.apartmentId" filterable @change="apartmentSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in apartmentOptions"
           :key="item.apartmentId"
           :label="item.apartmentName"
           :value="item.apartmentId">
          </el-option>
        </el-select>
        </el-form-item>
     
         <el-form-item :label="$t('roomList.buildingName')">
          <el-select style="width:150px" v-model="selectForm.buildingId" @change="buildingSelectChange" :placeholder="$t('roomList.choose')">
            <el-option
             v-for="item in buildingOptions"
             :key="item.buildingId"
             :label="item.buildingName"
             :value="item.buildingId">
            </el-option>
          </el-select>
         </el-form-item>
         <el-form-item :label="$t('roomList.floorName')">
           <el-select style="width:150px" clearable v-model="selectForm.floorId"  @change="floorSelectChange" :placeholder="$t('roomList.choose')">
             <el-option
              v-for="item in floorOptions"
              :key="item.floorId"
              :label="item.floorName"
              :value="item.floorId">
               </el-option>
            </el-select>
          </el-form-item>
   
           <el-button type="primary"  icon="el-icon-search" @click="">{{$t('roomList.search')}}</el-button>
      
           <el-table
              ref="roomDataTable"
              :data="roomData"
              :header-cell-style="{background: '#eef1f6', color: '#606266'}"
              empty-text="No Data"
              border
              @selection-change="handleChange"
              :row-key="getRowKeys"
              :max-height="330"
            >
             <el-table-column type="selection" :reserve-selection="true"></el-table-column>
             <el-table-column type="index" :label="$t('butler.number')"  width="100"  align="center"></el-table-column>
             <el-table-column prop="roomName" :label="$t('groupList.roomName')" align="center"></el-table-column>
           </el-table> 
            <Pagings
               :total="total"
               :offset="pageData.offset"
               :pageSize="pageData.pageNumber"
               @handleSizeChangeSub="handleSizeChange"
               @handleCurrentChangeSub="handleCurrentChange"
              >
             </Pagings>
            <el-footer style="margin-top:5px">
               <el-button style="float:right" type="primary"  @click="confirmChooseRoom">{{$t('groupList.comfirmChoose')}}</el-button>
            </el-footer>
          </el-form>  
        </el-dialog>
        
        <!-- 编辑分组 -->
        <el-dialog
          :title="$t('groupList.editGroup')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="editGroupVisible"
          width="700px"
          style="margin-top:-70px"
        >
         <el-form :inline="true" :model="editGroup" class="demo-form-inline">  
     
          <el-form-item
            :label="$t('groupList.groupName')"
            label-width="140px"
          >
            <el-input
              type="text"
              v-model.number="editGroup.groupName"
              maxlength="18"
              show-word-limit
              placeholder=""
              style="width: 200px"
            ></el-input>
          </el-form-item>
           
          <el-form-item>
            <el-button type="primary" @click="addGroupRoom">{{$t('groupList.addRoom')}}</el-button>
            <el-button type="primary" @click="onGroupDelete">{{$t('groupList.delRoom')}}</el-button>
          </el-form-item>

            <el-table
              :data="groupRoomData"
              :header-cell-style="{background: '#eef1f6', color: '#606266'}"
              empty-text="No Data"
              border
              @selection-change="roomChooseChange"
              :max-height="300"
            >
             <el-table-column type="selection"></el-table-column>
             <el-table-column type="index" :label="$t('butler.number')"  width="100"  align="center"></el-table-column>
             <el-table-column prop="roomName" :label="$t('groupList.roomName')" align="center"></el-table-column>
           </el-table> 

          <el-row
            style="margin-top:5px;display: flex; justify-content: center; align-items: center"
          >
            <el-button type="primary" @click="onEidtSubmit">{{
              $t("butler.confirm")
            }}</el-button>
            <el-button type="primary" @click="editGroupVisible = false">{{
              $t("butler.cancel")
            }}</el-button>
          </el-row>
         </el-form> 
        </el-dialog>

        <!-- 添加分组 -->
        <el-dialog
          :title="$t('groupList.addGroup')"
          :modal-append-to-body="false"
          :lock-scroll="false"
          :visible.sync="addGroupVisible"
          width="500px"
        >
         <el-form :inline="true" :model="addGroup" class="demo-form-inline">  
     

          <el-form-item
            :label="$t('groupList.groupName')"
            label-width="140px"
          >
            <el-input
              type="text"
              v-model.number="addGroup.groupName"
              maxlength="18"
              show-word-limit
              placeholder=""
              style="width: 200px"
            ></el-input>
          </el-form-item>
             
          <el-row
            style="display: flex; justify-content: center; align-items: center"
          >
            <el-button type="primary" @click="onSubmit">{{
              $t("butler.confirm")
            }}</el-button>
            <el-button type="primary" @click="addGroupVisible = false">{{
              $t("butler.cancel")
            }}</el-button>
          </el-row>
         </el-form> 
      </el-dialog>
     
      <el-row>
        <el-button
          icon="el-icon-plus"
          style="float:right"
          @click="openAddGroup"
          >{{$t('groupList.addGroup')}}</el-button>
      </el-row> 
      <template>
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
          style="margin-top:5px"
        >
          <el-table-column
            type="index"
            :label="$t('butler.number')"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="groupName"
            :label="$t('groupList.groupName')"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roomNames"
            :label="$t('groupList.roomName')"
            align="center"
            width="380"
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('groupList.createTime')"
            align="center"
            width="160"
            :formatter="this.$util.datetimeFormat"
          >
          </el-table-column>
            
          <el-table-column
            prop=""
            :label="$t('butler.operate')"
            align="center"
            width="160"
          >
            <template slot-scope="scope">
              <el-button
                style='margin-top:5px'
                size="mini"
                @click="openEditGroup(scope.$index, scope.row)"
                >{{ $t("role.edit") }}</el-button
              >
              <el-button
                style='margin-top:5px'
                type="danger"
                size="mini"
                :title="$t('butler.delete')"
                @click="onDelete(scope.$index, scope.row)"
              >{{ $t("roomDetail.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-main>
  </el-container>
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "groupList", //这个LoginName最好和引入的vue的LoginName相同
  data() {
    return {
      apartmentOptions:[],
      buildingOptions:[],
      floorOptions:[],
      selectForm:{
        apartmentId:"",
        buildingId:"",
        floorId:"",
        isEdit:false,
        groupId:''//保存选择房间分组的分组ID
      },
      pageData: {
        offset: 1,
        pageNumber: 10,
      },
      total: 1, //总条数
      roomData:[],
      multipleSelectionAll: [],
      addGroupVisible: false,
      editGroupVisible:false,
      groupRoomVisible:false,
      addGroup: {
        groupName:""
      },
      groupRoomData:[],
      editGroup: {
        groupId:'',
        groupName:""
      },
      tableData: [],
      roomSelectionAll: []
    };
  },
  components: {
    Pagings,
  },
  created() {
    this.power();
    // this.roomDataPower();
  },
  methods: {
    //选择分组房间事件
    roomChooseChange(val){
      this.roomSelectionAll=val;
    },
    //删除分组房间
    onGroupDelete(index,row){
      if(this.roomSelectionAll==""||this.roomSelectionAll.length==0){
        this.$message({
          message:this.$t("groupList.qxzyscdfzfj"),
          type: "warning",
        });
         return false;
      }
      this.$confirm(
        this.$t("groupList.cczjyjscfzfj"),
        this.$t("butler.hint"),
        {
          confirmButtonText: this.$t("butler.confirm"),
          cancelButtonText: this.$t("butler.cancel"),
          type: "warning",
        }
       ).then(() => {
          var roomGroupLinkerIds=[];
          for(var str in this.roomSelectionAll){
             roomGroupLinkerIds.push(this.roomSelectionAll[str].roomGroupLinkerId);
          }
          var formData = new FormData();
          formData.append("roomGroupLinkerId",roomGroupLinkerIds);
          this.$server
            .exam("/customer/apartment/deleteGroupRooms", formData)
            .then((data) => {
              if (data.code == 200) {
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.groupRoomDataPower();
                this.power();//刷新分组列表
              } else {
                this.$message({
                  message: data.message,
                  type: "warning",
                });
              }
            });
        }).catch(() => {
          this.$message({
            type: "info",
            message: this.$t("butler.cancelDelete"),
          });
        });  
    },
    //打开添加分组房间
    addGroupRoom(){
      this.groupRoomVisible=true;
      this.multipleSelectionAll=[];
      this.getApartmentList();
    },
    //确定选择分组房间
    confirmChooseRoom(){  
          var roomIds=[];
          for(var str in this.multipleSelectionAll){
            roomIds.push(this.multipleSelectionAll[str].roomId);
          }
          var formData = new FormData();
          formData.append("groupId", this.editGroup.groupId);
          formData.append("roomIds",roomIds);
          this.$server
            .exam("/customer/apartment/addGroupRooms", formData)
            .then((data) => {
              if (data.code == 200) {
                this.groupRoomVisible=false;
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.groupRoomDataPower();
                this.power();//刷新分组列表
              } else {
                this.$message({
                  message: data.message,
                  type: "warning",
                });
              }
            });
    },
    
    //分页多选返回记忆
    getRowKeys (row) {
      return row.roomId;
    },

    //添加分组房间时候复选框选择
    handleChange(selection){
      // alert("selection"+JSON.stringify(selection));
      this.multipleSelectionAll=selection;
    },
    // 数组对象去重
    reduceSame: function (arr) {
      let obj = {};
      return arr.reduce(function (prev, item) {
        obj[item.id] ? "" : (obj[item.roomId] = 1 && prev.push(item))
        return prev;
      }, []);
    },
    //删除分组
    onDelete(index, row) {
      this.$confirm(
        this.$t("groupList.cczjyjscfz")+"(" +
          row.groupName +
          this.$t("butler.deleteButler-confirm2"),
        this.$t("butler.hint"),
        {
          confirmButtonText: this.$t("butler.confirm"),
          cancelButtonText: this.$t("butler.cancel"),
          type: "warning",
        }
      )
      .then(() => {
          var formData = new FormData();
          formData.append("groupId", row.groupId);
          this.$server
            .exam("/customer/apartment/deleteApartmentGroup", formData)
            .then((data) => {
              if (data.code == 200) {
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.power();
              } else {
                this.$message({
                  message: data.message,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("butler.cancelDelete"),
          });
        });
    },
    //打开编辑分组房间
    openEditGroup(index, row) {
      this.editGroupVisible = true;
      this.editGroup.groupName = row.groupName;
      this.editGroup.groupId = row.groupId;
      this.groupRoomDataPower();
    },
    //打开添加分组
    openAddGroup() {
      this.addGroupVisible = true;
      this.addGroupForm.groupName = "";
    },  
    //添加分组
    onSubmit() {
      var groupName = this.addGroup.groupName;
      var formData = new FormData();
      if (groupName == "" || groupName == null) {
        this.$message({
          message:this.$t("groupList.qsrfzmc"),
          type: "warning",
        });
        return false;
     }
     formData.append("groupName", groupName );
       this.$server.exam("/customer/apartment/addApartmentGroup", formData).then((data) => {
         if (data.code == 200) {
          this.addGroupVisible = false;
          this.power();
         } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
         }
       });
    },
    
    //确定编辑分组
    onEidtSubmit() {
       var groupName = this.editGroup.groupName;
      
      var formData = new FormData();

      if (groupName == "" || groupName == null) {
        this.$message({
          message:this.$t("groupList.qsrfzmc"),
          type: "warning",
        });
        return false;
      }
      formData.append("groupId", this.editGroup.groupId);
      formData.append("groupName", groupName );
      this.$server.exam("/customer/apartment/editApartmentGroup", formData).then((data) => {
        if (data.code == 200) {
          this.editGroupVisible = false;
          this.power();
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },

    
     //公寓改变值事件
    apartmentSelectChange(apartmentId){
         this.selectForm.apartmentId=apartmentId;
         this.selectForm.buildingId='';
         this.selectForm.floorId="";
         this.getBuildingList();
        //  this.floorOptions=[];
    },

    //楼栋下拉选择值改变事件
    buildingSelectChange(){
      if(this.selectForm.buildingId==""||this.selectForm.buildingId==null){
         this.floorOptions=[];
         this.selectForm.floorId="";
      }else{
        this.selectForm.floorId="";
        this.getFloorList();
      } 
    },

    //楼层下拉选择值改变
    floorSelectChange(){
        this.pageData.offset=1;
        this.pageData.pageNumber=10;
        this.roomDataPower();
    },

    getFloorList(){
      var formData = new FormData();
      formData.append("apartmentId",this.selectForm.apartmentId);
      formData.append("buildingId",this.selectForm.buildingId);
      this.$server
      .exam("/customer/apartment/listBaseFloor", formData)
      .then(data => {
        if (data.code == 200) {
          this.floorOptions=data.data;
          this.pageData.offset=1;
          this.pageData.pageNumber=10;     
          this.roomDataPower();   
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

    getBuildingList(){
      var formData = new FormData();
      if(this.selectForm.apartmentId!=""&&this.selectForm.apartmentId!=null){
        formData.append("apartmentId", this.selectForm.apartmentId);
      }
      this.$server
      .exam("/customer/apartment/listBaseBuilding", formData)
      .then(data => {
        if (data.code == 200) {
          this.buildingOptions=data.data;
          this.floorOptions=[];//把楼层列表清空，需要选择楼栋后才得到列表   
          this.pageData.offset=1;
          this.pageData.pageNumber=10;
          this.roomDataPower();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

    getApartmentList(){
      var formData = new FormData();
      this.$server
      .exam("/customer/apartment/listOwnerApartment", formData)
      .then(data => {
        if (data.code == 200) {
          this.apartmentOptions=data.data;
          if(data.data.length>0){
            if(this.$route.query.apartmentId!=undefined&&this.$route.query.apartmentId!=""&&this.$route.query.apartmentId!=null){
               this.selectForm.apartmentId=this.$route.query.apartmentId;
            }else{
               this.selectForm.apartmentId=data.data[0].apartmentId;
            }
            this.getBuildingList();
            // this.roomDataPower();
          }
               
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    power() {
      var formData = new FormData();
      this.$server
        .exam("/customer/apartment/listGroup", formData)
        .then((data) => {
          if (data.code == 200) {
            this.tableData = data.data;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },

    roomDataPower() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      formData.append("apartmentId", this.selectForm.apartmentId);
      if(this.selectForm.buildingId!=''){
        formData.append("buildingId",this.selectForm.buildingId);
      }
      if(this.selectForm.floorId!=''){
        formData.append("floorId",this.selectForm.floorId);
      }
      this.$server
        .exam("/customer/apartment/listRooms", formData)
        .then((data) => {
          if (data.code == 200) {
            this.roomData = data.data.records;
            this.total = data.data.total;
            // this.$nextTick(() => {
            //   this.roomData.forEach((row) => {
            //     var selectData=JSON.stringify(this.multipleSelectionAll);
            //     if (selectData != null && selectData != "") {
            //       if (selectData.indexOf(row.roomId) >= 0) {
                     
            //          console.log(JSON.stringify(row))
            //          this.$refs.roomDataTable.toggleRowSelection(row);
            //       }
            //     }
            //   });
            // });

          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },

     groupRoomDataPower() {
      var formData = new FormData();
      formData.append("groupId", this.editGroup.groupId);
      this.$server
        .exam("/customer/apartment/listGroupRoom", formData)
        .then((data) => {
          if (data.code == 200) {
            this.groupRoomData = data.data;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },

    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.roomDataPower();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.roomDataPower();
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/butler/groupList.vue